module.exports = __webpack_public_path__ + "img/03mazda-cx5.e715a6b2.png";